export enum HealthAntivirusStatus {
    Disabled = 'disabled',
    Offline = 'offline',
    Online = 'online',
}